import api from "../utils/api";

function getUserMail() {
  const user = localStorage.getItem("adm_panel_user");
  if (!user) return null;
  try {
    return JSON.parse(user).email;
  } catch {
    return null;
  }
}

export async function fetchActiveBanners() {
  try {
    const mail = getUserMail();

    const res = await api.get("/banners/active", {
      headers: {
        "X-User-Mail": mail,
      },
    });

    return res.data;
  } catch (err) {
    console.error(err.response || err);
    throw new Error("Failed to fetch banners");
  }
}

export async function fetchAllBanners() {
  try {
    const res = await api.get("/banners/all", {
      headers: {
        "X-User-Mail": getUserMail(),
      },
    })
    return res.data
  } catch (err) {
    throw new Error("Failed to fetch all banners")
  }
}

// Call when user acts on banner
export async function recordBannerAction(bannerId, action, currentPage = 0) {
  try {
    const res = await api.post(
      "/banners/action",
      { bannerId, action, currentPage },
      {
        headers: {
          "X-User-Mail": getUserMail(),
        },
      }
    );
    return res.data;
  } catch (err) {
    throw new Error("Failed to record banner action");
  }
}